import React, { useRef, useState } from 'react';
import './index.css';
import {
    Form,
    Input,
    Button,
    DatePicker,
    Selector, Switch,
    NavBar, Toast, Cascader
} from 'antd-mobile'
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import { transformedData } from './region';
import { memberApi } from '../../features/member/api/memberApi';

const CUSTOM_TAG_VALUE = '__custom__';

// 新增球员与球员列表的职务、带队和状态规则保持一致。
const ROLE_TAG_OPTIONS = [
    { label: '无职务', value: '', icon: '👤' },
    { label: '常委', value: '常委', icon: '⭐' },
    { label: '秘书', value: '秘书', icon: '📋' },
    { label: '领队', value: '领队', icon: '🧭' },
    { label: '荣誉常委', value: '荣誉常委', icon: '🏅' },
    { label: '自定义', value: CUSTOM_TAG_VALUE, icon: '✦' },
];

const MEMBER_STATUS_OPTIONS = [
    { label: '正式队员', value: null, icon: '⚽', description: '计入正式名单' },
    { label: '临时队员', value: 1, icon: '⏳', description: '临时参与活动' },
    { label: '非正式队员', value: 3, icon: '🌱', description: '不计入正式名单' },
    { label: '离队队员', value: 4, icon: '👋', description: '保留历史数据' },
];


export default function UploadMember() {

    const [areaVisible, setAreaVisible] = useState(false)
    const [areavalue, setAreaValue] = useState([])

    const [userDetail, setUserDetail] = useState({ "memberNum": 2, "weight": 70, "height": 170 })
    const [roleDraft, setRoleDraft] = useState({
        selectedTag: '',
        customTag: '',
        leadsTeam: false,
        tempMember: null,
    });


    const onFinish = (values) => {
        const tagInfo = roleDraft.selectedTag === CUSTOM_TAG_VALUE
            ? roleDraft.customTag.trim()
            : roleDraft.selectedTag;
        if (roleDraft.selectedTag === CUSTOM_TAG_VALUE && !tagInfo) {
            Toast.show({ icon: 'fail', content: '请输入自定义职务名称' });
            return;
        }

        // 无职务且不带队为普通队员；有职务但不带队时 standingMember=2。
        const standingMember = roleDraft.leadsTeam ? 1 : (tagInfo ? 2 : null);
        setFormCommitLoading(true)
        Toast.show({
            icon: 'loading',
            duration: 0
        })
        memberApi.create({
            name: values.realName,
            birthday: values.birthday,
            mobile: values.number,
            area: areavalue.join(""),
            memberNum: userDetail.memberNum,
            height: userDetail.height,
            weight: userDetail.weight,
            admin: values.admin ? values.admin : 0,
            tagInfo: tagInfo || null,
            tempMember: roleDraft.tempMember,
            standingMember,
            position: values.placeLike.join(','),
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        icon: 'success',
                        content: '操作成功！'
                    })
                    navigate('/member')
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: response.data.msg
                    })
                }
            })
            .catch(function () {
                Toast.show({
                    icon: 'fail',
                    content: '操作失败，请联系管理员！'
                })
            })
            .finally(() => {
                setFormCommitLoading(false)
            });

    }

    const minDate = new Date('1950-01-01')

    const [formCommitLoading, setFormCommitLoading] = useState(false)
    const datePickerRef = useRef();

    const handleDatePickerClick = () => {
        datePickerRef.current?.open();
    };

    const navigate = useNavigate()

    // 数字资料改为直接输入，输入过程中仅保留非负整数。
    const handleNumberChange = (key, value) => {
        const normalizedValue = String(value ?? '').replace(/\D/g, '');
        setUserDetail(prevDetail => ({
            ...prevDetail,
            [key]: normalizedValue === '' ? '' : Number(normalizedValue),
        }));
    };


    return (
        <div className="upload-member-container has-unified-nav ui-page ui-page--with-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                添加新球员
            </NavBar>

            <main className="upload-member-content">
                <section className="upload-member-hero">
                    <div className="upload-member-hero-icon">＋</div>
                    <div>
                        <span>PLAYER PROFILE</span>
                        <strong>建立新球员档案</strong>
                        <p>完善球员身份与基础资料，带星号内容为必填项。</p>
                    </div>
                </section>

                <Form
                    className='upload-glass-form'
                    name='form'
                    onFinish={onFinish}
                    layout='vertical'
                    footer={
                        <div className="upload-submit-panel">
                            <Button
                                block
                                type='submit'
                                size='large'
                                loading={formCommitLoading}
                                className='upload-submit-btn'
                            >
                                新增球员
                            </Button>
                        </div>
                    }
                    initialValues={{}}
                >
                    <section className="upload-section-card upload-basic-card">
                        <div className="upload-panel-heading">
                            <i>01</i>
                            <div><strong>球员基础资料</strong><span>填写姓名、生日及联系方式</span></div>
                        </div>
                        <Form.Item className="upload-field" name='realName' label='真实姓名' rules={[{ required: true }]}>
                            <Input placeholder='请输入姓名' clearable />
                        </Form.Item>

                        <Form.Item className="upload-field" name='number' label='联系电话' rules={[{ required: true }]}>
                            <Input type='tel' placeholder='请输入手机号码' clearable />
                        </Form.Item>

                        <Form.Item
                            className="upload-field upload-date-field"
                            name='birthday'
                            label='出生日期'
                            trigger='onConfirm'
                            onClick={handleDatePickerClick}
                            rules={[{ required: true }]}
                        >
                            <DatePicker min={minDate} ref={datePickerRef}>
                                {value => value ? (
                                    <span className="upload-picker-value">{moment(value).format('YYYY-MM-DD')}</span>
                                ) : (
                                    <span className="upload-picker-placeholder">请选择日期</span>
                                )}
                            </DatePicker>
                        </Form.Item>

                        <Form.Item className="upload-field upload-area-field" name='areaInfo' label='籍贯'>
                            <div className="upload-area-control">
                                <Cascader
                                    options={transformedData}
                                    visible={areaVisible}
                                    onClose={() => setAreaVisible(false)}
                                    value={areavalue}
                                    onConfirm={value => setAreaValue(value)}
                                >
                                    {items => (
                                        <span className={items.every(item => item === null) ? 'is-placeholder' : ''}>
                                            {items.every(item => item === null)
                                                ? '未选择'
                                                : items.map(item => item?.label ?? '未选择').join('-')}
                                        </span>
                                    )}
                                </Cascader>
                                <Button fill='none' onClick={() => setAreaVisible(true)}>选择 <b>›</b></Button>
                            </div>
                        </Form.Item>
                    </section>

                    <section className="upload-section-card upload-role-panel">
                        <div className="upload-panel-heading">
                            <i>02</i>
                            <div><strong>职务与队员状态</strong><span>与球员列表的职务规则保持一致</span></div>
                        </div>
                        <div className="upload-role-block">
                            <div className="upload-role-head"><strong>职务</strong><span>选择预设名号，或填写自定义职务</span></div>
                            <div className="upload-role-tag-grid">
                                {ROLE_TAG_OPTIONS.map(option => (
                                    <button
                                        type="button"
                                        key={option.value || 'empty-role'}
                                        className={`upload-role-choice ${roleDraft.selectedTag === option.value ? 'is-selected' : ''}`}
                                        onClick={() => setRoleDraft(previous => ({ ...previous, selectedTag: option.value }))}
                                    >
                                        <span>{option.icon}</span>
                                        <strong>{option.label}</strong>
                                        {roleDraft.selectedTag === option.value && <i>✓</i>}
                                    </button>
                                ))}
                            </div>
                            {roleDraft.selectedTag === CUSTOM_TAG_VALUE && (
                                <div className="upload-role-custom-input">
                                    <Input
                                        value={roleDraft.customTag}
                                        maxLength={20}
                                        clearable
                                        placeholder="输入自定义职务，例如：赛事总监"
                                        onChange={value => setRoleDraft(previous => ({ ...previous, customTag: value }))}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="upload-role-block">
                            <div className="upload-role-head"><strong>是否参与带队</strong><span>正式队员参与后进入队长候选范围</span></div>
                            <div className="upload-leader-options">
                                <button
                                    type="button"
                                    className={`upload-leader-choice ${roleDraft.leadsTeam ? 'is-selected' : ''}`}
                                    onClick={() => setRoleDraft(previous => ({ ...previous, leadsTeam: true }))}
                                ><span>🧢</span><strong>参与带队</strong></button>
                                <button
                                    type="button"
                                    className={`upload-leader-choice ${!roleDraft.leadsTeam ? 'is-selected' : ''}`}
                                    onClick={() => setRoleDraft(previous => ({ ...previous, leadsTeam: false }))}
                                ><span>👤</span><strong>不参与带队</strong></button>
                            </div>
                        </div>

                        <div className="upload-role-block">
                            <div className="upload-role-head"><strong>队员状态</strong><span>正式、临时、非正式和离队状态分开管理</span></div>
                            <div className="upload-status-grid">
                                {MEMBER_STATUS_OPTIONS.map(option => (
                                    <button
                                        type="button"
                                        key={option.value === null ? 'formal' : option.value}
                                        className={`upload-status-choice ${roleDraft.tempMember === option.value ? 'is-selected' : ''}`}
                                        onClick={() => setRoleDraft(previous => ({ ...previous, tempMember: option.value }))}
                                    >
                                        <span>{option.icon}</span>
                                        <span><strong>{option.label}</strong><small>{option.description}</small></span>
                                        {roleDraft.tempMember === option.value && <i>✓</i>}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="upload-section-card upload-match-card">
                        <div className="upload-panel-heading">
                            <i>03</i>
                            <div><strong>比赛与身体资料</strong><span>设置位置、球衣号码和身体数据</span></div>
                        </div>
                        <Form.Item
                            className="upload-field upload-position-field"
                            name='placeLike'
                            label='位置偏好'
                            help='最多选择两个首选位置'
                            rules={[{ required: true }]}
                        >
                            <Selector
                                columns={4}
                                options={[
                                    { label: '门将', value: '1' },
                                    { label: '边后', value: '2' },
                                    { label: '中后', value: '3' },
                                    { label: '后腰', value: '4' },
                                    { label: '边前', value: '5' },
                                    { label: '前腰', value: '6' },
                                    { label: '前锋', value: '7' },
                                    { label: '裁判', value: '8' }
                                ]}
                                multiple
                                onChange={arr => {
                                    if (arr?.length > 2) {
                                        Toast.show('最多选择两个首选位置,超出首选位置个数将默认选择前两个默认位置');
                                    }
                                }}
                            />
                        </Form.Item>

                        <div className="upload-compact-grid">
                            <Form.Item className="upload-field upload-number-field" name='height' label='身高'>
                                <div className="upload-number-input">
                                    <Input
                                        type='number'
                                        inputMode='numeric'
                                        min={0}
                                        value={userDetail.height}
                                        placeholder='请输入'
                                        aria-label='身高'
                                        onChange={value => handleNumberChange('height', value)}
                                    />
                                    <span>cm</span>
                                </div>
                            </Form.Item>

                            <Form.Item className="upload-field upload-number-field" name='width' label='体重'>
                                <div className="upload-number-input">
                                    <Input
                                        type='number'
                                        inputMode='numeric'
                                        min={0}
                                        value={userDetail.weight}
                                        placeholder='请输入'
                                        aria-label='体重'
                                        onChange={value => handleNumberChange('weight', value)}
                                    />
                                    <span>kg</span>
                                </div>
                            </Form.Item>

                            <Form.Item className="upload-field upload-number-field upload-jersey-field" name='memberNum' label='球衣号码'>
                                <div className="upload-number-input">
                                    <Input
                                        type='number'
                                        inputMode='numeric'
                                        min={0}
                                        value={userDetail.memberNum}
                                        placeholder='请输入'
                                        aria-label='球衣号码'
                                        onChange={value => handleNumberChange('memberNum', value)}
                                    />
                                    <span>号</span>
                                </div>
                            </Form.Item>
                        </div>

                        <Form.Item className="upload-field upload-admin-field" name='admin'>
                            <div className="upload-switch-control">
                                <div><strong>设为系统管理员</strong><span>开启后将获得管理功能入口</span></div>
                                <Switch defaultValue={false} defaultChecked={false} uncheckedText='否' checkedText='是' />
                            </div>
                        </Form.Item>
                    </section>

                    <div className="upload-form-note">提交前请确认姓名、球衣号码、职务和队员状态填写正确。</div>
                </Form>
            </main>

        </div>
    );
}
